import { useQuery } from '@tanstack/react-query';
import { apiGet, operationsClient } from '@/lib/api/client';
import { serviceAreaEndpoints } from '@/lib/api/endpoints';
import { serviceAreaKeys } from '@/lib/queryKeys';

/**
 * A single covered ZIP enriched with its readable named area. `neighborhood` is
 * resolved from the ZIP centroid (may be null outside mapped areas); city/state
 * come from the same reverse-geocode with a centroid fallback.
 */
export interface CoverageArea {
  zipCode: string;
  neighborhood: string | null;
  city: string | null;
  state: string | null;
  county: string | null;
}

export function useCoverage() {
  return useQuery<CoverageArea[]>({
    queryKey: serviceAreaKeys.coverage(),
    queryFn: () => apiGet<CoverageArea[]>(operationsClient, serviceAreaEndpoints.coverage()),
  });
}
